export enum Environment {
  STAGING = 'staging',
  DEVELOPMENT = 'development',
  PRODUCTION = 'production'
}
